// extracted by css-extract-rspack-plugin
export default {"blurb":"Ubh7MinxwDQ1vwUR","heading":"oxmHf4ZUI68q339I","paragraph":"k2CdFQ6UvM48skyW"};